import { FunctionComponent, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

const Layout = lazy(() => import('./app/layout'));

const RouteSelectionPage = lazy(() => import('./app/route-selection.page'));
const ArrangementSelectionPage = lazy(() => import('./app/arrangement/arrangement-selection.page'));
const CalendarPage = lazy(() => import('#app/reservation/calendar.page'));
const NumberOfPersonsPage = lazy(() => import('#app/reservation/persons-selection.page.tsx'));
const SelectEntrancePage = lazy(() => import('#app/reservation/select-entrance.page.tsx'));
const TimeSelectionPage = lazy(() => import('#app/reservation/time-selection.page'));
const ExtrasPage = lazy(() => import('#app/reservation/upsell.page.tsx'));
const PersonalDetailsPage = lazy(() => import('#app/reservation/personal-details.page'));
const OverviewPage = lazy(() => import('#app/reservation/overview.page'));
const ConfirmationPage = lazy(() => import('#app/reservation/reservation-recieved.page.tsx'));

export const Router: FunctionComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route
            index
            element={<Navigate to="/reserveren" replace />}
          />
          <Route path="/demo" element={<RouteSelectionPage />} />

          {/* Reservation flow */}
          <Route path="/reserveren" element={<CalendarPage />} />
          <Route path="/reserveren/personen" element={<NumberOfPersonsPage />} />
          <Route path="/reserveren/entree" element={<SelectEntrancePage />} />
          <Route path="/reserveren/tijd" element={<TimeSelectionPage />} />
          <Route path="/reserveren/extras" element={<ExtrasPage />} />
          <Route path="/reserveren/persoonlijke-gegevens" element={<PersonalDetailsPage />} />
          <Route path="/reserveren/overzicht" element={<OverviewPage />} />
          <Route path="/reserveren/bevestiging" element={<ConfirmationPage />} />

          {/* Arrangement deeplink flow */}
          <Route path="/arrangement/:dealId/:dealName">
            <Route index element={<Navigate to="kalender" replace />} />
            <Route path="kalender" element={<CalendarPage />} />
            <Route path="personen" element={<NumberOfPersonsPage />} />
            <Route path="arrangement" element={<ArrangementSelectionPage />} />
            <Route path="tijd" element={<TimeSelectionPage />} />
            <Route path="extras" element={<ExtrasPage />} />
            <Route path="persoonlijke-gegevens" element={<PersonalDetailsPage />} />
            <Route path="overzicht" element={<OverviewPage />} />
            <Route path="bevestiging" element={<ConfirmationPage />} />
          </Route>
          <Route path="/arrangement-deeplink/*" element={<Navigate to="/" replace />} />

          {/* Treatment deeplink flow */}
          <Route path="/behandeling/:treatmentId/:treatmentName">
            <Route index element={<CalendarPage />} />
            <Route path="personen" element={<NumberOfPersonsPage />} />
            <Route path="tijd" element={<TimeSelectionPage />} />
            <Route path="persoonlijke-gegevens" element={<PersonalDetailsPage />} />
            <Route path="overzicht" element={<OverviewPage />} />
            <Route path="bevestiging" element={<ConfirmationPage />} />
          </Route>

        </Route>
      </Routes>
    </BrowserRouter>
  );
};
